import { aboutData } from '@/mocks/homeData';

export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex flex-col lg:flex-row items-center gap-8 lg:gap-14">
          <div className="flex-1 w-full text-center lg:text-left">
            <h2 className="text-xl md:text-3xl font-bold text-foreground-950 font-heading mb-2">{aboutData.title}</h2>
            <p className="text-sm text-foreground-500 mb-8">{aboutData.subtitle}</p>
            <div className="space-y-4">
              {aboutData.paragraphs.map((p, idx) => (
                <p key={idx} className="text-sm md:text-base text-foreground-600 leading-relaxed">{p}</p>
              ))}
            </div>
          </div>
          <div className="flex-1 w-full flex justify-center">
            <div className="relative w-full max-w-md aspect-square rounded-2xl overflow-hidden bg-background-200">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20digital%20news%20platform%20office%20with%20warm%20crimson%20and%20amber%20lighting%2C%20multiple%20screens%20displaying%20hot%20topics%2C%20dark%20atmospheric%20background%2C%20professional%20editorial%20environment%2C%20clean%20composition%2C%20cinematic%20photography%20style&width=800&height=800&seq=about-img-01&orientation=squarish"
                alt="91黑料网平台介绍"
                className="w-full h-full object-cover"
              />
              <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent"></div>
              <div className="absolute bottom-5 left-5 right-5">
                <span className="text-white text-lg font-bold font-heading">做最专业的吃瓜平台</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}